<div class="row justify-content-center align-items-center" style="min-height: 100vh;">
    <div class="col-6">
        <h3 class="{{message_class}}">{{message}}</h3>
    </div>
</div>
